module.exports = __webpack_public_path__ + "media/images/river/inspiration-afb81d8697d9408a8ebdf33ec64c2fbc.jpg";